import styled from 'styled-components';
import {
    scarpaGray100,
    scarpaGray200,
    scarpaGray500,
    scarpaGray900,
    spanishViridian25,
    spanishViridian500,
} from '@habitech/shared';

export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    border: 1px solid ${scarpaGray200};
    border-radius: 10px;
    background: white;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    color: ${scarpaGray900};

    thead th {
        text-align: left;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        font-size: 11px;
        color: ${scarpaGray500};
        background: ${scarpaGray100};
        padding: 12px;
        white-space: nowrap;
        border-bottom: 1px solid ${scarpaGray200};
    }

    tbody td {
        padding: 12px;
        border-bottom: 1px solid ${scarpaGray200};
        white-space: nowrap;
    }

    tbody tr:last-child td {
        border-bottom: none;
    }

    tbody tr.selected {
        background: ${spanishViridian25};
    }

    .checkbox-cell {
        width: 44px;
        text-align: center;
    }

    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        accent-color: ${spanishViridian500};
        cursor: pointer;
    }
`;

export const StatusBadge = styled.span<{ $active: boolean }>`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    color: ${({ $active }) => ($active ? spanishViridian500 : scarpaGray500)};
    background: ${({ $active }) => ($active ? spanishViridian25 : scarpaGray100)};
`;

export const EmptyState = styled.div`
    padding: 24px 12px;
    text-align: center;
    color: ${scarpaGray500};
    font-size: 14px;
`;

export const SortHeaderButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
    font: inherit;
    text-transform: inherit;
    letter-spacing: inherit;
    color: inherit;

    &:hover {
        color: ${spanishViridian500};
    }

    .sort-icon {
        display: inline-flex;
        opacity: 0.5;
        transition: opacity 0.15s ease;

        svg {
            fill: currentColor;
        }
    }

    &:hover .sort-icon {
        opacity: 1;
    }

    &.active {
        color: ${spanishViridian500};
    }

    &.active .sort-icon {
        opacity: 1;
        color: ${spanishViridian500};
    }
`;
